export default __webpack_public_path__ + "static/banner-d8ac02ff532956cdbd44241059725f9d.webp";